module.exports = __webpack_public_path__ + "static/6-aa91d8418e9bf592dfc0864941166f97.jpg";